// src/utils/websocket.js
let socket = null;

export default {
  // 初始化连接（示例）
  connect(url) {
    if (socket) socket.close();
    // 如果没有提供URL，使用默认的后端WebSocket地址
    const wsUrl = url || 'wss://shiguangtongpin.cn/ws';
    socket = new WebSocket(wsUrl);
    // 可以添加事件监听
    socket.onopen = () => console.log('WebSocket连接已打开');
    socket.onclose = () => console.log('WebSocket连接已关闭');
    socket.onerror = (err) => console.error('WebSocket错误:', err);
  },
  
  // 关闭连接
  close() {
    if (socket) {
      socket.close();
      socket = null;
    }
  },
  
  // 发送消息（示例）
  send(message) {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(message));
    }
  }
};